var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "search-field",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _vm.isDesktop
        ? _c("c-input", {
            staticClass: "field",
            attrs: {
              icon: "search",
              "data-cy": "menu-search-input",
              round: "",
              background: "",
              type: "text",
              value: _vm.term,
              placeholder: "Qual oferta você está procurando hoje?"
            },
            on: { input: _vm.input },
            nativeOn: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleAnalytics()
              }
            }
          })
        : _c(
            "div",
            { staticClass: "search-field-mobile" },
            [
              _c("k-icon", {
                staticClass: "icon",
                attrs: { icon: "search", size: "20" }
              }),
              _vm._v(" "),
              _c("input", {
                ref: "field",
                staticClass: "field",
                attrs: {
                  type: "text",
                  placeholder: "Busque por produtos ou marcas"
                },
                domProps: { value: _vm.term },
                on: { input: _vm.input }
              }),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide", mode: "in-out" } }, [
                _vm.term && _vm.term.length
                  ? _c(
                      "button",
                      {
                        staticClass: "clean",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$emit("reset")
                          }
                        }
                      },
                      [_vm._v("\n        Limpar\n      ")]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4260924a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4260924a","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchField.vue
// module id = 2109
// module chunks = 1610